<template>
	<div class="sticky-nav">

			<div class="left-bar left-bar-desktop rounded mh-custom wall-card v-card">
			<left-bar-items />
			</div>

	</div>
</template>

<script>
import LeftBarItems from '@/components/left-bar/LeftBarItems'
import {mapGetters} from 'vuex';
export default {
	components: {
		LeftBarItems
	},
	data() {
		return {
			drawer: true
		}
	},
	watch: {
		drawer(val) {
			this.$store.commit('application/setMenu', val)
		}
	},
	computed: {
		...mapGetters({
			menu: 'application/menu'
		})
	},
	created() {
		this.drawer = this.menu;
	}
}
</script>

<style lang="scss">
	.sticky-nav {
		position: sticky;
		top: calc(76px + 24px - 8px);
		position:-webkit-sticky;

	}

	.left-bar  {
		background: white;
		padding: 12px;
		font-size: 12px;
		&.left-bar-desktop {
			border: thin solid rgba(0, 0, 0, 0.12);
		}

	.logo,
	.logo-mini {
		height: 36px;
	}
	@media (min-width: 1904px) {
		padding-left: 21px;
		padding-right: 21px;
	}

	.menu-icon-wrap {
		margin-right: 8px;
	}
	.group-name {
		font-weight: 500;
		color: var(--v-grey-base);
		.group-title {
			white-space: nowrap;
		}
		.group-line {
			height: 1px;
			border-top: 1px solid #f0f0f0;
		}
	}
	.v-list {
		padding: 0px;
		.v-list-item {
			margin-bottom: 20px;
			&.v-list-item--active,
			&.v-list-item--link:before {
				// background-color: $secondary;
				background-color: var(--v-accent-lighten2);
			}
			.v-list-item {
				background-color: var(--v-accent-lighten2);
				margin: 0;
				border-radius: 0;
				display: none;
			}
			&.v-list-item--active {
				.v-list-item {
					display: flex;
				}
			}
			.v-list-item__title {
				padding: 14px 0;
				// display: flex;
				align-items: center;
				font-weight: 600;
				font-size: 14px !important;
				// width: 100%;
			}
			.menu-icon {
			}
		}
	}
	.v-list.nav-grey {
		.v-list-item--active,
		.v-list-item--link:before {
			background-color: $muted-light;
		}
	}
}
</style>
